import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import PNF from "../views/404.vue";
import Login from "../views/user/Login.vue";
import Register from "../views/user/Register.vue";
import EmailVerification from "../views/user/EmailVerification.vue";
import ResetPassword from "../views/user/ResetPassword.vue";
import Dashboard from "../views/user/Dashboard.vue";
// Dashboard children
import DashboardComponent from "../components/dashboard/DashboardComponent.vue";
import MessageComponent from "../components/dashboard/MessageComponent.vue";
import MessageViewComponent from "../components/dashboard/MessageViewComponent.vue";
import EditAccountComponent from "../components/dashboard/EditAccountComponent.vue";
import DeactivateAccountComponent from "../components/dashboard/DeactivateAccountComponent.vue";
import ConfirmIdentityComponent from "../components/dashboard/ConfirmIdentityComponent.vue";
import BookingsListComponent from "../components/dashboard/BookingsListComponent.vue";
import ReviewsListComponent from "../components/dashboard/ReviewsListComponent.vue";
import EditListingComponent from "../components/listing/edit/EditListingComponent.vue";
import EditPriceComponent from "../components/listing/edit/EditPriceComponent.vue";
import EditImagesComponent from "../components/listing/edit/EditImagesComponent.vue";
import EditVideoComponent from "../components/listing/edit/EditVideoComponent.vue";
import EditYoutubeVideoComponent from "../components/listing/edit/EditYoutubeVideoComponent.vue";
import EditMapComponent from "../components/listing/edit/EditMapComponent.vue";
import EditAvailabilityComponent from "../components/listing/edit/EditAvailabilityComponent.vue";
// Partners
import PartnerListingsComponent from "../components/dashboard/partner/ListingsComponent.vue";
import PartnerListingViewComponent from "../components/dashboard/partner/ListingViewComponent.vue";
import PartnerBookingsComponent from "../components/dashboard/partner/BookingsComponent.vue";
import PartnerBookingViewComponent from "../components/dashboard/partner/BookingViewComponent.vue";
import PartnerCancelBookingComponent from "../components/dashboard/partner/CancelBooking.vue";
import PartnerPayoutComponent from "../components/dashboard/partner/PayoutComponent.vue";
import PartnerContractComponent from "../components/dashboard/partner/ContractComponent.vue";
// Dashboard children
import AddListing from "../views/listing/AddListing.vue";
import SearchListing from "../views/listing/SearchListing.vue";
import GuestViewListing from "../views/listing/GuestViewListing.vue";
import GuestViewNPListing from "../views/listing/GuestViewNPListing.vue";
import ViewBooking from "../views/booking/ViewBooking.vue";
import CancelBookingRequest from "../views/booking/CancelBookingRequest.vue";
import ChangeBookingRequest from "../views/booking/ChangeBookingRequest.vue";
import ReviewBooking from "../views/booking/ReviewBooking.vue";
import CompleteBooking from "../views/booking/CompleteBooking.vue";
import CollectPayment from "../views/booking/CollectPayment.vue";

import store from "../store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/404",
    name: "PNF",
    component: PNF
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      noAuth: true
    }
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
    meta: {
      noAuth: true
    }
  },
  {
    path: "/email/verification/:id",
    name: "EmailVerification",
    component: EmailVerification,
    meta: {
      noAuth: true
    }
  },
  {
    path: "/reset/password",
    name: "ResetPassword",
    component: ResetPassword,
    meta: {
      noAuth: true
    }
  },
  {
    path: "/dashboard",
    component: Dashboard,
    meta: {
      requiresAuth: true
    },
    children: [
      { path: "", name: "Dashboard", component: DashboardComponent },
      {
        path: "messages",
        name: "MessageComponent",
        component: MessageComponent
      },
      {
        path: "messages/:id",
        name: "MessageViewComponent",
        component: MessageViewComponent
      },
      {
        path: "account/edit",
        name: "EditAccountComponent",
        component: EditAccountComponent
      },
      {
        path: "account/deactivate",
        name: "DeactivateAccountComponent",
        component: DeactivateAccountComponent
      },
      {
        path: "bookings",
        name: "BookingsListComponent",
        component: BookingsListComponent
      },
      {
        path: "reviews",
        name: "ReviewsListComponent",
        component: ReviewsListComponent
      },
      {
        path: "confirm-identity",
        name: "ConfirmIdentityComponent",
        component: ConfirmIdentityComponent
      },
      {
        path: "partner/listings",
        name: "PartnerListingsComponent",
        component: PartnerListingsComponent
      },
      {
        path: "partner/listing/:id",
        name: "PartnerListingViewComponent",
        component: PartnerListingViewComponent
      },
      {
        path: "partner/listing/:id/edit",
        name: "EditListingComponent",
        component: EditListingComponent
      },
      {
        path: "partner/listing/:id/edit/price",
        name: "EditPriceComponent",
        component: EditPriceComponent
      },
      {
        path: "partner/listing/:id/edit/images",
        name: "EditImagesComponent",
        component: EditImagesComponent
      },
      {
        path: "partner/listing/:id/edit/video",
        name: "EditVideoComponent",
        component: EditVideoComponent
      },
      {
        path: "partner/listing/:id/edit/youtube",
        name: "EditYoutubeVideoComponent",
        component: EditYoutubeVideoComponent
      },
      {
        path: "partner/listing/:id/edit/map",
        name: "EditMapComponent",
        component: EditMapComponent
      },
      {
        path: "partner/listing/:id/edit/availability",
        name: "EditAvailabilityComponent",
        component: EditAvailabilityComponent
      },
      {
        path: "partner/bookings",
        name: "PartnerBookingsComponent",
        component: PartnerBookingsComponent
      },
      {
        path: "partner/booking/:id",
        name: "PartnerBookingViewComponent",
        component: PartnerBookingViewComponent
      },
      {
        path: "partner/cancel/:id",
        name: "PartnerCancelBookingComponent",
        component: PartnerCancelBookingComponent
      },
      {
        path: "partner/payouts",
        name: "PartnerPayoutComponent",
        component: PartnerPayoutComponent
      },
      {
        path: "partner/contract/:id",
        name: "PartnerContractComponent",
        component: PartnerContractComponent
      }
    ]
  },
  {
    path: "/listing/add",
    name: "AddListing",
    component: AddListing,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/search/listing",
    name: "SearchListing",
    component: SearchListing
  },
  {
    path: "/member/listing/:id",
    name: "GuestViewListing",
    component: GuestViewListing
  },
  {
    path: "/member/np-listing/:id",
    name: "GuestViewNPListing",
    component: GuestViewNPListing
  },
  {
    path: "/review-booking",
    name: "ReviewBooking",
    component: ReviewBooking,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/payment/:id",
    name: "CompleteBooking",
    component: CompleteBooking,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/collect-payment/:id",
    name: "CollectPayment",
    component: CollectPayment,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/view/booking/:id",
    name: "ViewBooking",
    component: ViewBooking,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/cancel/booking/:id",
    name: "CancelBookingRequest",
    component: CancelBookingRequest,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/change/booking/:id",
    name: "ChangeBooking",
    component: ChangeBookingRequest,
    meta: {
      requiresAuth: true
    }
  }
];

const router = new VueRouter({
  mode: "history",
  linkActiveClass: "active",
  linkExactActiveClass: "exact-active",
  routes
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.name)) {
    next();
  } else {
    next("/404");
  }
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next();
      return;
    }
    next("/login?redirect=" + to.path);
  } else {
    next();
  }
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.noAuth)) {
    if (!store.getters.isLoggedIn) {
      next();
      return;
    }
    next("/");
  } else {
    next();
  }
});

export default router;
